<section class="section-white" *ngIf="applyData" id="downloadForm">
  <div class="section-container-inside">
    <div class="whitepaper-container">
      <div class="whitepaper-content">
        <h3 class="be-truly-heading mar-b-24">
          {{ applyData?.header }}
        </h3>
        <div
          class="section-description align-l mar-b-48"
          [innerHtml]="applyData?.paragraph | toHtml"
        ></div>
      </div>
      <div class="whitepaper-form-container">
        <div id="hubspotDownloadForm" class="w-100"></div>
      </div>
    </div>
  </div>
</section>
